import {Route} from '@angular/router';

/**
 * Aplana `router.config` en la lista de rutas que ofrece el autocompletado del
 * campo "link" del editor de items.
 *
 * De las rutas perezosas cuelgan sus hijas en `_loadedRoutes`, una propiedad
 * **interna de Angular** que sólo existe una vez cargado ese módulo. Al entrar
 * en `/items` recargando la URL todavía no se ha cargado ninguno, así que hay
 * que contar con que falte: en ese caso la ruta perezosa aporta sólo su propio
 * camino y sus hijas aparecerán cuando el módulo se cargue y se vuelva a montar
 * la pantalla. Sin esa cautela, la recursión recibía `undefined` y la pantalla
 * entera se caía con "Cannot read properties of undefined (reading 'filter')".
 */
export function extraerRutas(rutas: Route[], parentPath: string = null): string[] {
    return (rutas || [])
        .filter(r => r.path !== '')
        .map(ruta => {
            const rutaPath = parentPath ? parentPath + '/' + ruta.path : ruta.path;
            const hijas: Route[] = (ruta as any)._loadedRoutes;
            if (ruta.loadChildren instanceof Function && hijas) {
                return [...extraerRutas(hijas, rutaPath), rutaPath];
            }
            return [rutaPath];
        })
        .reduce((acumulado, rutasDeLaRama) => [...rutasDeLaRama, ...acumulado], []);
}
